import React, { useState, useEffect } from "react";
import throttle from "lodash/throttle";
import { useSelector } from "react-redux";
import { get } from "lodash";

import { object, shape } from "prop-types";
import { LazyCollection, LazyLoadImages, replaceAllStoriesInCollection, WithPreview } from "@quintype/components";

import TaboolaScript from "../ads/taboola-ad/load-taboola-ad";
import TaboolaAd from "../ads/taboola-ad";
// import NewTopBanner from "../atoms/new-top-banner";
import NewIframeTopBanner from "../atoms/new-iframe-top-banner";

import { setIsLogin, setUserDetails } from "../store/actions";


import { getCollectionTemplate } from "../get-collection-template";

export const HomePage = ({ data }) => {
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(false);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const topBannerConfig = qtState?.data?.frontendConfig?.topBannerConfig;
  const avoidUrls = Array.isArray(topBannerConfig?.avoidUrl)
      ? topBannerConfig.avoidUrl
      : typeof topBannerConfig?.avoidUrl === "string"
        ? [topBannerConfig.avoidUrl]
        : [];

  const checkUrls = [
    "http://localhost:3000",
    "https://deccanherald-training2-web.quintype.io/",
    "https://deccanherald-training2-web.quintype.io",
    "https://dh-sandbox-web.quintype.io/",
    "https://dh-sandbox-web.quintype.io",
    "https://www.deccanherald.com/",
    "https://www.deccanherald.com",
    "https://deccanherald-training-web.quintype.io/",
    "https://deccanherald-training-web.quintype.io"
  ];
  const avoidHomePage = checkUrls.some((url) =>
    avoidUrls.includes(url)
  );

  useEffect(() => {
    const getScroll = () => {
      if (typeof window !== "undefined") {
        if (window.scrollY > 500) setRenderTaboolaAd(true);
      }
    };
    window.addEventListener("scroll", throttle(getScroll, 500));
    return () => window.removeEventListener("scroll", getScroll);
  }, []);

  return (
    <div className="container">
      <TaboolaScript type="homepage" />
      {!avoidHomePage && <NewIframeTopBanner sectionPage={false} />}
      <LazyLoadImages>
        <LazyCollection
          minHeight={0}
          collection={data?.collection}
          collectionTemplates={getCollectionTemplate}
          lazyAfter={2}
          className="lazy-collection"
        />
      </LazyLoadImages>
      {renderTaboolaAd ? (
        <TaboolaAd container="taboola-below-home-thumbnails" placement="Below Home Thumbnails" mode="thumbnails-a" />
      ) : null}
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object
  })
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story)
  })
);
